import {
    actionCreator,
    API_URL,
    checkHttpStatus,
    create_post_data,
    createRequestActionTypes,
    createSearchUrl,
    jsonApiHeader,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage,
} from '../../../../../actions/utilAction';


export {
    jsonApiHeader,
    showWarningMessage,
    showErrorMessage,
    actionCreator,
    checkHttpStatus,
    create_post_data,
    createSearchUrl,
    showSuccessMessage
};

export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;
export const SAVE_DEFAULT_TARGET_SETTINGS = `${API_URL}/api/MasterDataDefaultTargetSetting/SaveMasterDataDefaultTargetSetting`;
export const GET_DEFAULT_TARGET_SETTINGS = `${API_URL}/api/MasterDataDefaultTargetSetting/GetMasterDataDefaultTargetSetting`;

export const DefaultSettingsActionTypes = {
    get_masterData: createRequestActionTypes('GET_MASTERDATA'),
    save_defaultTargetSettings:createRequestActionTypes('SAVE_DEFAULT_TARGET_SETTINGS'),
    get_defaultTargetSettings:createRequestActionTypes('GET_DEFAULT_TARGET_SETTINGS')
}





// WEBPACK FOOTER //
// ./src/modules/MastersDataCollection/settings/defaultSettings/constants/ApiConstants.js